import { PropsWithChildren } from 'react';

import { ScreenReaderOnly } from '@opendoor/bricks/utils';

const Fieldset: React.FC<PropsWithChildren<{ questionTitle?: string }>> = ({
  questionTitle,
  children,
}) => {
  if (questionTitle) {
    return (
      <fieldset style={{ border: 'none' }}>
        <ScreenReaderOnly as="legend">{questionTitle}</ScreenReaderOnly>
        {children}
      </fieldset>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default Fieldset;
